var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject, bindable } from "aurelia-framework";
import "amcharts3";
import "amcharts3/amcharts/pie.js";
import "amcharts3/amcharts/serial.js";
import "amcharts3/amcharts/gauge.js";
import "amcharts3/amcharts/plugins/export/export.js";
import "amcharts3/amcharts/plugins/animate/animate.js";
import "amcharts3/amcharts/plugins/dataloader/dataloader.js";
import "amcharts3/amcharts/plugins/responsive/responsive.js";
import { Guid } from "../../../utilities/guid";
import { ChartBaseTypes } from "./chart";
var Gauge = /** @class */ (function () {
    function Gauge() {
        this.id = Guid.generateGuid();
        this.value = 0;
    }
    Gauge.prototype.attached = function () {
        this.chart = this.init();
        this.isAttached = true;
        this.setValue(this.value);
    };
    Gauge.prototype.valueChanged = function () {
        this.setValue(this.value);
    };
    Gauge.prototype.setValue = function (value) {
        if (value >= 0 && this.isAttached) {
            this.chart.arrows[0].setValue(value);
            this.chart.axes[0].setTopText(Math.round(value) + " %");
            // adjust darker band to new value
            this.chart.axes[0].bands[1].setEndValue(value);
        }
    };
    Gauge.prototype.init = function () {
        var options = {
            hideCredits: true,
            path: "src/views/components/chart/amcharts",
            type: ChartBaseTypes.Gauge,
            marginBottom: -20,
            marginLeft: 0,
            marginTop: 10,
            marginRight: 0,
            axes: [{
                    topTextFontSize: 20,
                    topTextYOffset: 110,
                    axisColor: "#4a4a4a",
                    axisThickness: 2,
                    endValue: 100,
                    gridInside: true,
                    inside: false,
                    radius: "100%",
                    valueInterval: 10,
                    tickColor: "#4a4a4a",
                    startAngle: -90,
                    endAngle: 90,
                    unit: "%",
                    bandOutlineAlpha: 0,
                    bands: [{
                            color: "#f9f9f9",
                            endValue: 100,
                            innerRadius: "50%",
                            radius: "100%",
                            gradientRatio: [0.2, 0, -0.2],
                            startValue: 0
                        }, {
                            color: "#65BAF9",
                            endValue: 0,
                            innerRadius: "50%",
                            radius: "100%",
                            gradientRatio: [0.2, 0, -0.2],
                            startValue: 0
                        }]
                }],
            arrows: [{
                    alpha: 1,
                    innerRadius: "0%",
                    nailRadius: 0,
                    radius: "100%"
                }],
            responsive: {
                enabled: this.responsive
            },
            export: {
                enabled: this.exportEnabled,
                divId: this.exportDivId,
                libs: {
                    autoLoad: false,
                }
            }
        };
        return window["AmCharts"].makeChart("chartdiv-".concat(this.id), options);
    };
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Gauge.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Gauge.prototype, "exportEnabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Gauge.prototype, "exportDivId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Gauge.prototype, "responsive", void 0);
    Gauge = __decorate([
        autoinject,
        transient()
    ], Gauge);
    return Gauge;
}());
export { Gauge };
